// Slash command registry. Hints reflect the bindings actually wired in
// useModeShortcuts.ts, formatted for the active platform.

import { chord } from '@/lib/platform';

export interface SlashCommand {
  name: string;            // without leading slash
  description: string;
  hint?: string;           // shown right of label
  args?: string;           // e.g. "<topic>"
  category: 'session' | 'agent' | 'workflow' | 'utility';
}

export const SLASH_COMMANDS: SlashCommand[] = [
  { name: 'plan',        description: 'Plan an approach before coding',          category: 'workflow', args: '<task>' },
  { name: 'debug',       description: 'Reproduce, isolate, fix a bug',           category: 'workflow', args: '<symptom>' },
  { name: 'research',    description: 'Multi-step research with web + docs',     category: 'workflow', args: '<topic>' },
  { name: 'code',        description: 'Code-focused session',                    category: 'workflow', args: '<task>' },
  { name: 'review',      description: 'Review code or diff',                     category: 'workflow', args: '<target>' },
  { name: 'agent',       description: 'Switch active agent',                     category: 'agent',    args: '<kind>' },
  { name: 'model',       description: 'Switch model',                            category: 'agent',    args: '<id>' },
  { name: 'tools',       description: 'Show available tools',                    category: 'agent' },
  { name: 'clear',       description: 'Clear current session messages',          category: 'session',  hint: chord('mod', 'shift', 'L') },
  { name: 'attach',      description: 'Attach files / folder',                   category: 'session' },
  { name: 'new-session', description: 'Start a fresh session',                   category: 'session',  hint: chord('mod', 'shift', 'N') },
];

export function findCommand(name: string): SlashCommand | undefined {
  return SLASH_COMMANDS.find((c) => c.name === name);
}
